import React from 'react';
import { Button } from '@Thread-Magic/jasmine';
import { Wrapper, Banner, Description, ButtonWrapper, Title } from './PartnerM365Integration.style';

const PartnerM365Integration = () => {
  return (
    <>
      <Wrapper>
        <Banner>
          <div>
            <img src="/images/m365-logo.png" width="80" alt="M365 logo" />
          </div>
          <Description>
            <Title>Connect M365 to see Teams usage.</Title>
            <p>
              Connect to the Partner Center in Microsoft 365 to see Teams usage of your clients.
            </p>
          </Description>
          <ButtonWrapper>
            <Button styleMode="outline">Connect</Button>
          </ButtonWrapper>
        </Banner>
      </Wrapper>
    </>
  );
};

export default PartnerM365Integration;
